<template>
  <div>
    <section class="home-slider py-4 d-none d-xl-block">
      <slick :options="homeSlider">
        <div v-for="(homeSlider, homes) in 5" :key="homes">
          <div class="slider-container">
            <div class="slider-content shadow" style="overflow:hidden">
              <div class="d-flex align-items-center">
                <div class="col-md-4 pl-0">
                  <img
                    src="@/assets/img/cold-pursuit.jpg"
                    class="img-fluid rounded-left"
                    style="position: relative;"
                  >
                  <span class="text-pink movie-cat">Alternate</span>
                </div>
                <div class="col-md-8 align-self-start">
                  <h1 class="text-pink my-4">Cold Pursuit</h1>

                  <div class="d-flex align-items-center">
                    <ul class="list-inline movie-detail">
                      <li class="list-inline-item">
                        <span class="font-weight-bold">PG-13</span>
                      </li>
                      <li class="list-inline-item">Documentary</li>
                      <li class="list-inline-item">English</li>
                    </ul>

                    <ul class="list-inline ml-3 movie-format">
                      <li class="list-inline-item">2D</li>
                      <li class="list-inline-item">3D</li>
                    </ul>
                  </div>

                  <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellat similique illo excepturi officia est iusto perspiciatis quidem blanditiis? Ipsa enim rem at necessitatibus dolor quam numquam nam provident culpa dolores?</p>

                  <div class="d-flex align-items-center justify-content-start">
                    <div class="imdb-container">
                      <div class="box-1">IMdb</div>
                      <div class="box-2">9.2</div>
                    </div>

                    <div class="ml-5">
                      <span class="small mb-0">User Rating</span>
                      <p class="mb-0 d-flex">
                        4.3
                        <span class="ml-2">
                          <img src="@/assets/img/star-rating.png" height="20" width="100">
                        </span>
                      </p>
                    </div>
                  </div>
                  <hr>
                  <div class="d-flex align-items-center justify-content-start">
                    <div class>
                      <div class>08 Feb, 2019</div>
                    </div>

                    <div class="ml-5">
                      <p class="mb-0">2hrs 00 mins</p>
                    </div>
                  </div>
                  <button class="btn cus-btn shadow px-4 py-2 my-5">Book Now</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </slick>
    </section>

    <div class="section-space-min"></div>

    <section class="container-fluid">
      <div class="col-12 col-lg-11 mx-auto">
        <div class="row">
          <div class="col-md-3 col-lg-3 col-xl-2">
            <div class="accordian-continer">
              <div v-b-toggle.cinemas class="btn-accordian">Cinemas</div>
              <b-collapse id="cinemas">
                <div class="accordian-content">
                  <div>
                    <div class="btn-accordian-child" v-b-toggle.reelCamera>Reel Camera</div>
                    <b-collapse id="reelCamera">
                      <ul class="list-unstyled">
                        <li>Dubai Mall</li>
                        <li>Dubai Marina Mall</li>
                        <li>Rove Donwtown</li>
                        <li>The Pointe</li>
                      </ul>
                    </b-collapse>
                  </div>

                  <div>
                    <div class="btn-accordian-child" v-b-toggle.dolbyCinema>Reel Camera</div>
                    <b-collapse id="dolbyCinema">
                      <ul class="list-unstyled">
                        <li>Dubai Mall</li>
                        <li>Dubai Marina Mall</li>
                        <li>Rove Donwtown</li>
                        <li>The Pointe</li>
                      </ul>
                    </b-collapse>
                  </div>

                  <div>
                    <div class="btn-accordian-child mb-0" v-b-toggle.novoCinema>Reel Camera</div>

                    <b-collapse id="novoCinema">
                      <ul class="list-unstyled">
                        <li>Duabi Mall</li>
                        <li>Dubai Marina Mall</li>
                        <li>Rove Donwtown</li>
                        <li>The Pointe</li>
                      </ul>
                    </b-collapse>
                  </div>
                </div>
              </b-collapse>
            </div>

            <div class="accordian-continer">
              <div v-b-toggle.language class="btn-accordian">Language</div>
              <b-collapse id="language">
                <div class="accordian-content">
                  <p class="card-text">Collapse contents Here</p>
                </div>
              </b-collapse>
            </div>

            <div class="accordian-continer">
              <div v-b-toggle.genre class="btn-accordian">Genre</div>
              <b-collapse id="genre">
                <div class="accordian-content">
                  <p class="card-text">Collapse contents Here</p>
                </div>
              </b-collapse>
            </div>

            <div class="accordian-continer">
              <div v-b-toggle.format class="btn-accordian">Format</div>
              <b-collapse id="format">
                <div class="accordian-content">
                  <p class="card-text">Collapse contents Here</p>
                </div>
              </b-collapse>
            </div>
          </div>

          <div class="col-9 col-md-9 col-lg-9 col-xl-10">
            <div class="movie-times" v-for="(moviect, mtime) in 5" :key="mtime">
              <p>PVR ECX Mall of India - Noida</p>
              <ul class="list-inline">
                <li class="list-inline-item" v-for="(moviet, time) in 5" :key="time">
                  <router-link to="/">
                    <span>11:45</span>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Slick from "vue-slick";

export default {
  components: {
    Slick
  },
  data() {
    return {
      homeSlider: {
        dots: true,
        arrows: true,
        slidesToShow: 1,
        centerMode: true,
        slidesToScroll: 2,
        centerPadding: "180px"
      }
    };
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/pages/show.vue